import Cookies from './autoload/_js-cookie';

$(() => {

  let welcomeModal = $('#welcome-modal');


  if ( Cookies.get('no-welcome-modal') == null ) {
    welcomeModal.modal('show');
  }

  welcomeModal.on('shown.bs.modal', function () {
    // $(this).find('video').get(0).play();
  }).on('hide.bs.modal', function() {

    welcomeModal.find('iframe').attr('src', '');

    if ($(this).find('.turn-modal-off .form-check-input').is(':checked')) {
      if ( Cookies.get('no-welcome-modal') == null ) {
        Cookies.set('no-welcome-modal', 'true', {
          expires: 7, // 7 days
        })
      }
    }
    else {
      if ( Cookies.get('no-welcome-modal') == null ) {
        Cookies.set('no-welcome-modal', 'true', {
          expires: new Date(new Date().getTime() + 30 * 60 * 1000), // 30 mins
        })
      }
    }

  })

  $('#welcome-modal .learn-more').on('click', function() {
    if ($('#welcome-modal .turn-modal-off .form-check-input').is(':checked')) {
      if ( Cookies.get('no-welcome-modal') == null ) {
        Cookies.set('no-welcome-modal', 'true', {
          expires: 7, // 7 days
        })
      }
    }
    else {
      if ( Cookies.get('no-welcome-modal') == null ) {
        Cookies.set('no-welcome-modal', 'true', {
          expires: new Date(new Date().getTime() + 30 * 60 * 1000), // 30 mins
        })
      }
    }
  })

});


// WEBPACK FOOTER //
// ./scripts/welcome-modal.js